// stageNav.js
export function mountStageNav({ root = document, onSelect, canSelect }) {
  function getButtons() {
    return Array.from(root.querySelectorAll('.story-stage button[data-stage]'));
  }

  function setActive(stageId) {
    getButtons().forEach((b) => {
      b.classList.toggle('active', b.dataset.stage === stageId);
    });
  }

  function reset() {
    getButtons().forEach((b) => b.classList.remove('active'));
  }

  const onClick = (e) => {
    const btn = e.target.closest('.story-stage button[data-stage]');
    if (!btn || !root.contains(btn)) return;

    const stageId = btn.dataset.stage;

    if (canSelect && !canSelect(stageId)) return;

    setActive(stageId);
    onSelect?.(stageId);
  };

  const onPointerDown = (e) => {
    const btn = e.target.closest('.story-stage button[data-stage]');
    if (!btn || !root.contains(btn)) return;
    e.preventDefault();
    e.stopPropagation();
  };

  if (!getButtons().length) return;

  root.addEventListener('pointerdown', onPointerDown);
  root.addEventListener('click', onClick);

  function destroy() {
    root.removeEventListener('pointerdown', onPointerDown);
    root.removeEventListener('click', onClick);
  }

  return {
    destroy,
    reset,
    setActive,
  };
}
